import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Row,
  Col,
  HorizontalRule,
  HeadingFive,
  ParagraphTitle,
  SmallText,
  Paragraph
} from '../../legacy/hui/src/styled';
import styled, { css } from 'styled-components';
import { formatDate } from '../utils/date';
import { transparentize } from 'polished';
import Attachments from './JobDetails/Attachments';
import Questions from './JobDetails/Questions';
import Description from './JobDetails/DescriptionViewMore';
import ErrorBoundary from './ErrorBoundary';
import { getThumborURL } from '../utils/thumbor';
import { ButtonSubmit } from './Bunnings/Buttons';
import { Link } from 'react-router-dom';

export const THUBOR_SIZE = '959x298';

const borderRadius = props =>
  !props.modal &&
  css`
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  `;

const CardHead = styled.div`
  padding: 1.875rem 1rem;
  color: ${props => props.theme.snow};
  position: relative;
  background-size: cover;
  text-align: center;
  &:before {
    content: '';
    display: block;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    ${borderRadius};
  }
  ${borderRadius};
`;

const CardHeadTitle = HeadingFive.extend`
  font-size: 18px;
`;

const JobFieldLabel = Col.extend`
  font-weight: 600;
  padding: 0;
  margin: 0;
`;

const JobFieldValue = Col.extend`
  text-align: right;
  margin: 0;
  padding: 0;
`;

const Divider = HorizontalRule.extend`
  height: 1px;
  background-color: ${props => transparentize(0.8, props.theme.muted)};
  margin-top: 1.25rem;
  margin-bottom: 0;
`;

const DetailRow = Row.extend`
  padding: 1rem 1.5rem 0 1.5rem;
  max-width: 100vw;
`;

const HelpText = Col.extend`
  font-size: 20px;
  color: #0d5257;
`;

const PhoneText = Col.extend`
  font-size: 20px;
  color: #0d5257;
  padding-bottom: 20px;
`;

const WordsText = styled.div`
  font-size: 16px;
  padding-left: 10px;
`;

const JobDetails = ({ job, category, location }) => (
  <div id="jbt">
    <Card snow p={0} mt={{ xs: 0, lg: 1 }}>
      <CardHead
        style={{ backgroundImage: `url(${getThumborURL(category.thumbnail, THUBOR_SIZE)})` }}
      >
        <div style={{ position: 'relative' }}>
          <CardHeadTitle>{category.name}</CardHeadTitle>
          <SmallText mb={'7px'}>
            {formatDate(job.postedDate)}, {location.suburb}
          </SmallText>
        </div>
      </CardHead>
      <DetailRow>
        <JobFieldLabel xs={4}>Category:</JobFieldLabel>
        <JobFieldValue xs={8}>{category.name}</JobFieldValue>
        <Divider />
      </DetailRow>
      <DetailRow>
        <JobFieldLabel xs={4}>Location:</JobFieldLabel>
        <JobFieldValue xs={8}>
          {location.suburb}, {location.postcode}
        </JobFieldValue>
        <Divider />
      </DetailRow>
      <DetailRow>
        <JobFieldLabel xs={4}>Address:</JobFieldLabel>
        <JobFieldValue xs={8}>{job.address}</JobFieldValue>
        <Divider />
      </DetailRow>
      <ErrorBoundary name="attachments">
        {job.attachments && !!job.attachments.length && (
          <DetailRow>
            <JobFieldLabel xs={4}>Photos:</JobFieldLabel>
            <JobFieldValue xs={8}>
              <Attachments attachments={job.attachments} />
            </JobFieldValue>
            <Divider />
          </DetailRow>
        )}
      </ErrorBoundary>
      <DetailRow>
        <Col xs={12}>
          <ParagraphTitle p={0}>Description:</ParagraphTitle>
          <Description>
            <Paragraph>{job.details}</Paragraph>
            {!!job.questions.length && <Questions questions={job.questions} />}
            {(job.contactName || job.mobile || job.phone || job.email) && (
              <div>
                <Divider />
                <ParagraphTitle pt="1rem">My details:</ParagraphTitle>
                {job.contactName && (
                  <Paragraph m={0} p={0}>
                    {job.contactName}
                  </Paragraph>
                )}
                {job.mobile && (
                  <Paragraph m={0} p={0}>
                    {job.mobile}
                  </Paragraph>
                )}
                {job.phone && (
                  <Paragraph m={0} p={0}>
                    {job.phone}
                  </Paragraph>
                )}
                {job.email && (
                  <Paragraph m={0} p={0}>
                    {job.email}
                  </Paragraph>
                )}
              </div>
            )}
            <Divider />
            <Row pt={1} gutter={0}>
              <JobFieldLabel xs={4} gutter={0}>
                ID:
              </JobFieldLabel>
              <JobFieldValue xs={8} gutter={0}>
                {job.id}
              </JobFieldValue>
            </Row>
          </Description>
        </Col>
      </DetailRow>
    </Card>
    <Link to="/install">
      <ButtonSubmit snow tag="span" mt={1}>
        Enter another install code
      </ButtonSubmit>
    </Link>
    <Card snow p={0} mt={0.8} mb={1}>
      <Row p="1rem 1.5rem 0 1.5rem">
        <HelpText>Need Help?</HelpText>
      </Row>
      <Row p="1rem 1.5rem 0 1.5rem">
        <WordsText>
          If you require help at any stage during your install you can call the dedicated support
          phone line
        </WordsText>
      </Row>
      <Row p="1rem 1.5rem 0 1.5rem">
        <PhoneText>1300 043 520</PhoneText>
      </Row>
    </Card>
  </div>
);

JobDetails.propTypes = {
  job: PropTypes.object,
  category: PropTypes.object,
  location: PropTypes.object
};

export default JobDetails;
